import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

const StatusHeader = ({ error }) => {
  return (
    <Stack alignItems="center" spacing={2} sx={{ pb: 7, pt: 3 }} width="100%">
      {!error ? (
        <>
          <DoneIcon
            sx={{
              color: 'secondary.main',
              fontSize: '48px',
            }}
          />
          <Typography variant="h5">Your Shipment(s) were Successfully Submitted</Typography>
          <Typography variant="body1">
            Your new Shipment(s) were successfully created with the information listed below.
          </Typography>
        </>
      ) : (
        <>
          <CloseIcon
            sx={{
              color: 'error.main',
              fontSize: '48px',
            }}
          />
          <Typography variant="h5">Your Shipment(s) Could Not be Created.</Typography>
          <Typography variant="body1">{error}</Typography>
        </>
      )}
    </Stack>
  );
};

StatusHeader.propTypes = {
  error: PropTypes.string,
};
StatusHeader.defaultProps = {
  error: '',
};

export default StatusHeader;
